import AuthWindow from './AuthWindow';

export default AuthWindow;